export function elementGetOffsetTop (el) {
  let top = 0;
  let $el = el;

  if(el) {
    while ($el !== document.body) {
      top += $el.offsetTop;
      if($el.offsetParent) {
        $el = $el.offsetParent;
      } else {
        break;
      }
    }

    return top - 150
  } else {
    return false
  }
}
